@if (certification) {
  <div class="cert-detail">

    <div class="cert-detail__lesson-header">
      <button
        type="button"
        class="cert-detail__back-link"
        (click)="goBack()"
      >
        <svg class="cert-detail__back-icon" width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M0.833374 4.16634H12.0834C14.1544 4.16634 15.8334 5.84527 15.8334 7.91634C15.8334 9.98741 14.1544 11.6663 12.0834 11.6663H8.33337M0.833374 4.16634L4.16671 0.833008M0.833374 4.16634L4.16671 7.49967" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Back to Certifications</span>
      </button>
    </div>

    <div class="cert-detail__content-card">

      <div class="cert-detail__top">
        <div class="cert-detail__hero">
          <span class="cert-detail__hero-label">Certification</span>
          <h1 class="cert-detail__hero-title">{{ certification.name }}</h1>
        </div>

        <div class="cert-detail__stepper">
          <ol class="cert-detail__stepper-track" aria-label="Certification process steps">

            <li class="cert-detail__step">
              <div class="cert-detail__step-icon cert-detail__step-icon--current" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#req_clip)">
                    <path d="M5.00008 12.5001L6.66675 14.1667L10.4167 10.4167M6.66675 6.66675V4.33341C6.66675 3.39999 6.66675 2.93328 6.8484 2.57676C7.00819 2.26316 7.26316 2.00819 7.57676 1.8484C7.93328 1.66675 8.39999 1.66675 9.33341 1.66675H15.6667C16.6002 1.66675 17.0669 1.66675 17.4234 1.8484C17.737 2.00819 17.992 2.26316 18.1518 2.57676C18.3334 2.93328 18.3334 3.39999 18.3334 4.33341V10.6667C18.3334 11.6002 18.3334 12.0669 18.1518 12.4234C17.992 12.737 17.737 12.992 17.4234 13.1518C17.0669 13.3334 16.6002 13.3334 15.6667 13.3334H13.3334M4.33341 18.3334H10.6667C11.6002 18.3334 12.0669 18.3334 12.4234 18.1518C12.737 17.992 12.992 17.737 13.1518 17.4234C13.3334 17.0669 13.3334 16.6002 13.3334 15.6667V9.33341C13.3334 8.39999 13.3334 7.93328 13.1518 7.57676C12.992 7.26316 12.737 7.00819 12.4234 6.8484C12.0669 6.66675 11.6002 6.66675 10.6667 6.66675H4.33341C3.39999 6.66675 2.93328 6.66675 2.57676 6.8484C2.26316 7.00819 2.00819 7.26316 1.8484 7.57676C1.66675 7.93328 1.66675 8.39999 1.66675 9.33341V15.6667C1.66675 16.6002 1.66675 17.0669 1.8484 17.4234C2.00819 17.737 2.26316 17.992 2.57676 18.1518C2.93328 18.3334 3.39999 18.3334 4.33341 18.3334Z" stroke="#414651" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs><clipPath id="req_clip"><rect width="20" height="20" fill="white"/></clipPath></defs>
                </svg>
              </div>
              <span class="cert-detail__step-label">Requirements</span>
            </li>

            <li class="cert-detail__step">
              <div class="cert-detail__step-icon cert-detail__step-icon--not-reached" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.16675 8.33331V13.3426C4.16675 13.6417 4.16675 13.7913 4.21229 13.9233C4.25257 14.0401 4.3183 14.1465 4.40473 14.2347C4.50247 14.3345 4.63625 14.4014 4.9038 14.5352L9.4038 16.7852C9.62243 16.8945 9.73175 16.9491 9.84642 16.9707C9.94797 16.9897 10.0522 16.9897 10.1537 16.9707C10.2684 16.9491 10.3777 16.8945 10.5964 16.7852L15.0964 14.5352C15.3639 14.4014 15.4977 14.3345 15.5954 14.2347C15.6819 14.1465 15.7476 14.0401 15.7879 13.9233C15.8334 13.7913 15.8334 13.6417 15.8334 13.3426V8.33331M1.66675 7.08331L9.70194 3.06571C9.81126 3.01105 9.86592 2.98372 9.92325 2.97297C9.97403 2.96344 10.0261 2.96344 10.0769 2.97297C10.1342 2.98372 10.1889 3.01105 10.2982 3.06571L18.3334 7.08331L10.2982 11.1009C10.1889 11.1556 10.1342 11.1829 10.0769 11.1936C10.0261 11.2032 9.97403 11.2032 9.92325 11.1936C9.86592 11.1829 9.81126 11.1556 9.70194 11.1009L1.66675 7.08331Z" stroke="#414651" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <span class="cert-detail__step-label">Knowledge Check</span>
            </li>

            <li class="cert-detail__step">
              <div class="cert-detail__step-icon cert-detail__step-icon--not-reached" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.5 8.33341H2.5M13.3333 1.66675V5.00008M6.66667 1.66675V5.00008M8.75 11.6667L10 10.8334V15.0001M8.95833 15.0001H11.0417M6.5 18.3334H13.5C14.9001 18.3334 15.6002 18.3334 16.135 18.0609C16.6054 17.8212 16.9878 17.4388 17.2275 16.9684C17.5 16.4336 17.5 15.7335 17.5 14.3334V7.33341C17.5 5.93328 17.5 5.23322 17.2275 4.69844C16.9878 4.22803 16.6054 3.84558 16.135 3.6059C15.6002 3.33341 14.9001 3.33341 13.5 3.33341H6.5C5.09987 3.33341 4.3998 3.33341 3.86502 3.6059C3.39462 3.84558 3.01217 4.22803 2.77248 4.69844C2.5 5.23322 2.5 5.93328 2.5 7.33341V14.3334C2.5 15.7335 2.5 16.4336 2.77248 16.9684C3.01217 17.4388 3.39462 17.8212 3.86502 18.0609C4.3998 18.3334 5.09987 18.3334 6.5 18.3334Z" stroke="#414651" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <span class="cert-detail__step-label">Registration</span>
            </li>

            <li class="cert-detail__step">
              <div class="cert-detail__step-icon cert-detail__step-icon--not-reached" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.5001 13.3333V5.99992C17.5001 5.0665 17.5001 4.59979 17.3184 4.24327C17.1586 3.92966 16.9037 3.6747 16.5901 3.51491C16.2335 3.33325 15.7668 3.33325 14.8334 3.33325H5.16675C4.23333 3.33325 3.76662 3.33325 3.4101 3.51491C3.09649 3.6747 2.84153 3.92966 2.68174 4.24327C2.50008 4.59979 2.50008 5.0665 2.50008 5.99992V13.3333M3.88897 16.6666H16.1112C16.6278 16.6666 16.8862 16.6666 17.0981 16.6098C17.6733 16.4557 18.1225 16.0064 18.2766 15.4313C18.3334 15.2193 18.3334 14.961 18.3334 14.4444C18.3334 14.186 18.3334 14.0569 18.305 13.9509C18.228 13.6633 18.0033 13.4387 17.7158 13.3616C17.6098 13.3333 17.4806 13.3333 17.2223 13.3333H2.77786C2.51953 13.3333 2.39037 13.3333 2.2844 13.3616C1.99682 13.4387 1.7722 13.6633 1.69514 13.9509C1.66675 14.0569 1.66675 14.186 1.66675 14.4444C1.66675 14.961 1.66675 15.2193 1.72354 15.4313C1.87765 16.0064 2.3269 16.4557 2.90205 16.6098C3.11399 16.6666 3.37232 16.6666 3.88897 16.6666Z" stroke="#414651" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <span class="cert-detail__step-label">Test Cycle</span>
            </li>

          </ol>
        </div>
      </div>

      <div class="cert-detail__divider" aria-hidden="true"></div>

      <div class="cert-detail__bottom">

        <div class="cert-detail__main">

          <section class="cert-detail__section" aria-labelledby="section-requirements">
            <div class="cert-detail__section-heading">
              <h2 id="section-requirements" class="cert-detail__section-title">Requirements</h2>
              <p class="cert-detail__section-subtitle">To participate in the certification process, you must meet the following requirements:</p>
            </div>
          </section>

          <section class="cert-detail__section" aria-labelledby="section-knowledge-check">
            <div class="cert-detail__section-heading">
              <h2 id="section-knowledge-check" class="cert-detail__section-title">Knowledge Check</h2>
              <p class="cert-detail__section-subtitle">This quiz will confirm that you fully understand the content and are ready for the test cycle.</p>
            </div>
          </section>

          <section class="cert-detail__section" aria-labelledby="section-registration">
            <div class="cert-detail__section-heading">
              <h2 id="section-registration" class="cert-detail__section-title">Registration</h2>
              <p class="cert-detail__section-subtitle">Our Academy team conducts test cycles at regular intervals. Register for this certification test cycle and we will email you the invitation once ready.</p>
            </div>
          </section>

          <section class="cert-detail__section" aria-labelledby="section-test-cycle">
            <div class="cert-detail__section-heading">
              <h2 id="section-test-cycle" class="cert-detail__section-title">Test Cycle</h2>
              <p class="cert-detail__section-subtitle">Once accepted to a test cycle, you will be able to start.</p>
            </div>
          </section>

          <div class="cert-detail__section cert-detail__section--faq">
            <ut-academy-faq [sections]="faqSections" />
          </div>

        </div>

        <aside class="cert-detail__sidebar">
          <div class="cert-detail__about-card">
            <h2 class="cert-detail__about-title">About this certification</h2>
            <p class="cert-detail__about-description">{{ certification.description }}</p>
          </div>
        </aside>

      </div>

    </div>

  </div>
}
